import { FullScreen } from "~/components/screens/FullScreen"

export default function NotFound() {
	return (
		<FullScreen
			title="Resource Not Found"
			message="This resource does not exist. Please contact your administrator if you think this is a mistake."
		/>
	)
}
